import { Input } from '@tiendanube/components';
import Stack from 'commons/components/Stack';

function MexicanAddressSkeleton() {
  return (
    <Stack column align="stretch">
      <Stack.Item>
        <Input.Skeleton />
      </Stack.Item>
      <Stack.Item>
        <Input.Skeleton />
      </Stack.Item>
      <Stack.Item>
        <Input.Skeleton />
      </Stack.Item>
      <Stack.Item>
        <Input.Skeleton />
      </Stack.Item>
      <Stack.Item>
        <Stack spacing="tight">
          <Stack.Item fill>
            <Input.Skeleton />
          </Stack.Item>
          <Stack.Item fill>
            <Input.Skeleton />
          </Stack.Item>
        </Stack>
      </Stack.Item>
    </Stack>
  );
}

export default MexicanAddressSkeleton;
